import React, { useState } from "react";

import FooterLinks from "../../../../components/LandingPage/FooterLinks";
import CommonHeader from "../../../../components/common/CommonHeader";

const faqData = [
  // Group 1: Introduction
  {
    question: "What is Million2Trillion?",
    answer:
      "Million2Trillion is a verified global ecosystem platform for financial market professionals. It connects traders, investors, coders, educators, fund managers, and more — offering tools to grow, earn, and collaborate inside a trusted environment.",
  },
  {
    question: "How does it work?",
    answer:
      "Users join with a verified SmartCard login. Based on their role, they unlock access to personalized dashboards, services, monetization tools, community features, and business opportunities.",
  },
  {
    question: "Why is it different from other platforms?",
    answer:
      "M2T is not just another app — it’s a verified ecosystem built from scratch. Every user is real, every feature is role-based, and every action is monetizable.",
  },
  {
    question: "Who can join the platform?",
    answer:
      "Anyone with a real financial market-related role: traders, educators, coders, analysts, investors, legal experts, and even fintech startups.",
  },
  {
    question: "Is it another trading platform?",
    answer:
      "No. We don’t offer trading ourselves. Instead, we help verified users offer services, products, and value to the financial market ecosystem.",
  },

  // Group 2: Earnings & Launch
  {
    question: "Can I earn from day one?",
    answer:
      "Yes. Once verified, you can start earning through your SmartCard — by offering services, joining the marketplace, or promoting your role.",
  },
  {
    question: "Will I make passive income?",
    answer:
      "Yes. You earn by referring users, promoting your SmartCard, or building value that continues to bring you clients over time.",
  },
  {
    question: "What is the meaning of 'Launch'?",
    answer:
      "'Launch' refers to our M2T LaunchPad — a module where you can test and launch your new product, strategy, or business inside our trusted ecosystem.",
  },
  {
    question: "Will I be able to test my new product in BetaLab (Launch)?",
    answer:
      "Yes. BetaLab is our internal sandbox to showcase, test, and get real feedback on your innovation before public rollout.",
  },
  {
    question: "How can I get funding for my innovation or launch?",
    answer:
      "Use our Deal Desk & VC access zone. If your product is verified and impactful, we help you reach investors and business partners.",
  },

  // Group 3: SmartCard, Access, Security
  {
    question: "How can I use my SmartCard?",
    answer:
      "Your SmartCard is your verified identity — it unlocks your dashboard, monetization features, affiliate tools, and helps promote your expertise.",
  },
  {
    question: "Who can access complete features in Million2Trillion?",
    answer:
      "Only verified users can unlock full features — like dashboards, monetization tools, offer listings, and AI support.",
  },
  {
    question: "Am I allowed to post general media?",
    answer:
      "Yes — but only inside role-based zones like M2T Stream, Offer Zone, or Learning Hub. Every post must add value.",
  },
  {
    question: "How are my funds and transactions secured?",
    answer:
      "Payments are held securely, released only after confirmation. KYC, encryption, and compliance systems protect every transaction.",
  },

  // Group 4: Business Growth & Promotion
  {
    question: "Why should I use Million2Trillion?",
    answer:
      "Because it’s a verified system built for serious financial professionals. It gives you tools, visibility, monetization, and global trust.",
  },
  {
    question: "How does the directory help us?",
    answer:
      "The directory helps others find you based on your role. You become visible globally to clients, partners, and service seekers.",
  },
  {
    question: "How do I get verified?",
    answer:
      "By submitting your profile, role details, and proof of work. Once approved, your SmartCard becomes active.",
  },
  {
    question: "How does this platform promote my business?",
    answer:
      "We auto-promote your verified role, content, and SmartCard to other users inside your category — and even outside via affiliate layers.",
  },
  {
    question: "Do I need to spend more money on ads?",
    answer:
      "No. The platform itself promotes you. Every verified user is a promoter — that’s the beauty of the circular growth system.",
  },
  {
    question: "Will I get global exposure?",
    answer:
      "Yes. Your SmartCard, offers, and posts are discoverable across 100+ countries. Verified users get search visibility.",
  },

  // Group 5: Platform Logic & AI
  {
    question: "What is the 6-Mission Hub?",
    answer:
      "It’s our core growth engine: Connect, Trade, Learn, Earn, Build, Launch. Every feature is designed to help you achieve these.",
  },
  {
    question: "How does AI assistance work for me?",
    answer:
      "Our AI tools help write content, create offers, auto-respond to inquiries, and assist in matching with clients or partners.",
  },
  {
    question:
      "If someone misuses the platform, how do you protect our privacy?",
    answer:
      "Strict verification, reporting tools, compliance systems, and human moderation ensure your data, identity, and business are safe.",
  },
];

export default function FAQPage() {
  const [visibleCount, setVisibleCount] = useState(10);

  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + 10, faqData.length));
  };

  const handleGoTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="mx-auto w-full bg-black py-0 text-white">
      <CommonHeader />
      <div className="mx-auto w-full max-w-4xl bg-black px-4 py-12 text-white sm:px-6 lg:px-12">
        <h1 className="mb-8 text-center text-4xl font-bold">
          What You Need to Know
        </h1>

        {faqData.slice(0, visibleCount).map((faq, idx) => (
          <div key={idx} className="mb-6">
            <h2 className="mb-1 text-lg font-semibold">❓ {faq.question}</h2>
            <p className="pl-2 text-white">{faq.answer}</p>
          </div>
        ))}

        {visibleCount < faqData.length && (
          <div className="text-center">
            <button
              onClick={handleShowMore}
              className="rounded bg-blue-600 px-6 py-2 text-white hover:bg-blue-700"
            >
              Show More
            </button>
          </div>
        )}

        {visibleCount > 10 && (
          <div className="mt-6 text-center">
            <button
              onClick={handleGoTop}
              className="text-blue-600 underline hover:text-blue-800"
            >
              Go to Top
            </button>
          </div>
        )}
      </div>
      <div className="mt-24">
        <FooterLinks />
      </div>
    </div>
  );
}
